import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Form } from '@rocketseat/unform';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';

import { toggleLoading } from '~/store/modules/main/actions';
import { toggleModal } from '~/store/modules/modal/actions';

import Button from '../../components/Button';
import api from '../../services/api';
import { ContainerForm, Header, InputResume, CustomDiv } from './styles';

function FormTipoUsuario({ data: dados, setRefresh }) {
  const [data] = useState(dados.dataLoad);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const handleSubmit = async formData => {
    dispatch(toggleLoading(true));
    let save = {};
    if (!formData.id) {
      save = await api.put('tipousuario', {
        ...formData,
        dataAlteracao: new Date(),
      });
    }

    const { status, message } = save.data;
    if (status) {
      enqueueSnackbar(message, { variant: 'success' });
      setRefresh(refresh => !refresh);
      dispatch(toggleModal(false, null, null, null));
    } else {
      enqueueSnackbar(message, { variant: 'error' });
    }
    dispatch(toggleLoading(false));
  };

  return (
    <ContainerForm>
      <Header>
        <h1>Tipo de Usuário</h1>
        <span>Administração de Tipos de Usuários</span>
      </Header>
      <Form onSubmit={handleSubmit} initialData={data}>
        <InputResume id="id" name="id" style={{ display: 'none' }} />
        <CustomDiv>
          <label htmlFor="nome">Nome do Usuário</label>
          <InputResume name="nome" id="nome" readOnly />
        </CustomDiv>
        <CustomDiv>
          <label htmlFor="email">Email</label>
          <InputResume name="email" id="email" readOnly />
        </CustomDiv>
        <Button handleClick={() => {}} text="Salvar" backColor="#5b5c65" color="#FFF" style={{ marginTop: '10px', right: '0' }} />
      </Form>
    </ContainerForm>
  );
}

FormTipoUsuario.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default FormTipoUsuario;
